import { render, staticRenderFns } from "./lead-details.vue?vue&type=template&id=5970dc32&scoped=true&"
import script from "./lead-details.vue?vue&type=script&lang=js&"
export * from "./lead-details.vue?vue&type=script&lang=js&"
import style0 from "./lead-details.vue?vue&type=style&index=0&id=5970dc32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970dc32",
  null
  
)

export default component.exports